import { HashRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "../layout/Mainlayout";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("../pages/Home"));
const ShopSportsGear = lazy(() => import("../pages/ShopSportsGear"));
const Events = lazy(() => import("../pages/Events"));
const BeyondCourt = lazy(() => import("../pages/BeyondCourt"));
const GetTrained = lazy(() => import("../pages/GetTrained"));
const StartPlaying = lazy(() => import("../pages/StartPlaying"));
const WhereToPlay = lazy(() => import("../pages/WhereToPlay"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Company = lazy(() => import("../pages/Company"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));

export default function AppRouter() {
  return (
    <Suspense
      fallback={
        <div className="w-full h-screen flex items-center justify-center">
          <div className="w-[50px] h-[50px]">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
              <circle fill="#0A0104" stroke="#0A0104" strokeWidth="2" r="15" cx="40" cy="100">
                <animate
                  attributeName="opacity"
                  calcMode="spline"
                  dur="1.6s"
                  values="1;0;1;"
                  keySplines=".5 0 .5 1;.5 0 .5 1"
                  repeatCount="indefinite"
                  begin="-.4s"
                />
              </circle>
              <circle fill="#0A0104" stroke="#0A0104" strokeWidth="2" r="15" cx="100" cy="100">
                <animate
                  attributeName="opacity"
                  calcMode="spline"
                  dur="1.6s"
                  values="1;0;1;"
                  keySplines=".5 0 .5 1;.5 0 .5 1"
                  repeatCount="indefinite"
                  begin="-.2s"
                />
              </circle>
              <circle fill="#0A0104" stroke="#0A0104" strokeWidth="2" r="15" cx="160" cy="100">
                <animate
                  attributeName="opacity"
                  calcMode="spline"
                  dur="1.6s"
                  values="1;0;1;"
                  keySplines=".5 0 .5 1;.5 0 .5 1"
                  repeatCount="indefinite"
                  begin="0s"
                />
              </circle>
            </svg>
          </div>
        </div>
      }
    >
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop-sports-gear" element={<ShopSportsGear />} />
            <Route path="/events" element={<Events />} />
            <Route path="/beyond-court" element={<BeyondCourt />} />
            <Route path="/get-trained" element={<GetTrained />} />
            <Route path="/start-playing" element={<StartPlaying />} />
            <Route path="/where-to-play" element={<WhereToPlay />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/company" element={<Company />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          </Routes>
        </MainLayout>
      </Router>
    </Suspense>
  );
}
